// @flow

import React, { Component } from "react";
import { NavHashLink as NavLink } from "react-router-hash-link";
import LeftIndicator from "../LeftIndicator";
import TechnicalCard from "../TechnicalCard";
import Movie from "../Movie";
import ResponsiveImage from "../ResponsiveImage";
import {
  Accordion,
  AccordionItem,
  AccordionItemState,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel
} from "react-accessible-accordion";
import "./RoofStep3.scss";

const uuidv4 = require('uuid/v4');

export default class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: false
    };
  }

  toggleMenu() {
    this.setState({
      menu: !this.state.menu
    });
  }

  closeMenu() {
    this.setState({
      menu: false
    });
  }
  getClosestParent(element, selector) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        (s => {
          var matches = (this.document || this.ownerDocument).querySelectorAll(
              s
            ),
            i = matches.length;
          while (--i >= 0 && matches.item(i) !== this) {}
          return i > -1;
        });
    }

    // Get the closest matching element
    for (; element && element !== document; element = element.parentNode) {
      if (element.matches(selector)) return element;
    }
    return null;
  }

  handleClic3(event) {
    console.log(event.target);
    let parent = this.getClosestParent(event.target, ".accordion__item");
    let activeItems = document.querySelectorAll(".active-acc__item3");
    activeItems.forEach(item => item.classList.remove("active-acc__item3"));
    parent.classList.add("active-acc__item3");
  }
  render() {
    return (
      <React.Fragment>
        <section id="roof-step3" className="roof-step3">
          <div className="roof-step3_container container  row">
            <div className="col-6 col-ml-12 photo-col">
              {/*  <ResponsiveImage imageName={"szybka-powloka-small.jpg"} imageClass={"picture"} /> */}
              <img src="/img/szybka-powloka-small.jpg" className="picture" />
              <div className="indicator-wrapper">
                {/*  <LeftIndicator fastShell /> */}
              </div>
            </div>
            <div className="col-6 col-ml-12 roof-photo-description step-3__desc">
              <div className="roof-description-background">
                <p key={"iss3"} className="h1-white-big">Krok 3</p>
                <p key={"iss4"} className="h3-red">Nanoszenie szybkiej powłoki</p>
                <p key={"iss5"} className="description-title-white">
                  Szybka powłoka{" "}
                  <span className="small-title__white">
                    polimerowo-bitumiczna
                  </span>
                </p>
                <p key={"iss6"} className="text-basic">
                  Szybką powłokę Evomer, podobnie jak grunt, można nanosić
                  szczotką, pędzlem, wałkiem lub natryskowo.
                </p>
                <p key={"iss7"} className="text-basic">
                  Grubość jednej warstwy to
                  <span className="text-important">0,4-0,5 mm</span>.
                </p>
                <div key={"iss8"} className="text-basic">
                  Wystarczy ona przy typowej renowacji powłok dachowych.
                </div>
                <p key={"iss9"} className="text-basic white-color">
                  Powłoka Evomer wstępnie wysycha już po
                  <p className="text-important">30 min. – po 2 godz.</p> jest
                  odporna na deszcz.
                </p>
              </div>
              <div className="big-roof__title">dachy</div>
            </div>
          </div>

          <div className="step-3__video row">
            <div className="container logo-title">
              <div className="logo-title__wrapper flex-title">
                <img src="/img/evomer-logo-white.png" className="logo-white" />
                <p className="h3-red left-margin">Szybka powłoka</p>
              </div>
            </div>
            <div className="video_container">
              <div className="indicator-container">
                {/*   <LeftIndicator fastShell/> */}
              </div>
              <div className="container video__wrapper">
                <div className="col-12 row">
                  <Movie
                    videoURL="../movies/szybka_powłoka.mp4"
                    image="../img/szybka-powloka-movie.jpg"
                  />
                </div>
              </div>
              <div className="col-12 container  advice">
                <p className="advice-title-roof">Rada fachowca</p>
                <p className="advice-text">
                  Gdy zachodzi potrzeba odtworzenia powłoki hydroizolacyjnej,
                  należy nanieść dwie warstwy. W celu wzmocnienia powłoki
                  aplikowanej na trudne podłoża, zaleca się zatopienie w niej
                  włókniny poliestrowej ok. 80 g/m2 w pierwszej warstwie
                  powłoki.
                </p>
              </div>
            </div>

            <div id="fastShellArea" className="col-12 technical-card fast-ground__wrapper">
              <div className="container logo-title">
                <div className="logo-title__wrapper">
                  <img
                    src="/img/evomer-logo-white.png"
                    className="logo-white"
                  />
                  <div className="sub-title__ccontainer">
                    <p className="h3-red fast-ground">Szybka powłoka</p>
                    <p className="description-title-white">
                      Polimerowo-bitumiczna
                    </p>
                  </div>
                </div>
              </div>
              <div className="fast-ground__container">
                <div className="indicator-wrapper">
                  {/* <LeftIndicator fastShell /> */}
                </div>
                <div className="col-12 selects-wrapper container row">
                  <div className="col-6 col-ml-12 selects ">
                    <div className="selects-container">
                      <Accordion>
                        <AccordionItem>
                          <AccordionItemHeading
                            onClick={this.handleClic3.bind(this)}
                          >
                            <AccordionItemButton>
                              <span className="af-icon-plus visible-icon"></span>
                              <span className="af-icon-minus hidden-icon"></span>
                              Benefity
                            </AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel>
                            <ul className="benefits-list">
                              <li className="list-item">
                                szybkoschnąca i odporna na deszcz – już po 2
                                godzinach
                              </li>
                              <li className="list-item">
                                bezpieczna dla styropianu
                              </li>
                              <li className="list-item">
                                nie zawiera rozpuszczalników – niepalna,
                                bezwonna
                              </li>
                              <li className="list-item">
                                podwyższona odporność na promieniowanie UV do 5
                                lat
                              </li>
                              <li className="list-item">
                                odporna na temperatury – zachowuje elastyczność
                                w -20oC,
                              </li>
                              <li className="list-item">
                                nie spływa z pionowych powierzchni w temp +90oC
                              </li>
                              <li className="list-item">wysokowydajna</li>
                              <li className="list-item">
                                tworzy powłokę trwale elastyczną pokrywającą
                                pęknięcia i szczeliny
                              </li>
                              <li className="list-item">
                                doskonała przyczepność
                              </li>
                              <li className="list-item">
                                bezpieczna dla środowiska
                              </li>
                            </ul>
                          </AccordionItemPanel>
                        </AccordionItem>

                        <AccordionItem>
                          <AccordionItemHeading
                            onClick={this.handleClic3.bind(this)}
                          >
                            <AccordionItemButton>
                              <span className="af-icon-plus visible-icon"></span>
                              <span className="af-icon-minus hidden-icon"></span>
                              Sposób aplikacji
                            </AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel>
                            <h5 className="small-header">
                              Przygotowanie produktu
                            </h5>
                            <p className="acc__para">
                              Produkt po wymieszaniu jest gotowy do użycia.
                            </p>

                            <h5 className="small-header">
                              Przygotowanie podłoża
                            </h5>
                            <p className="acc__para">
                              Podłoże przed aplikacją należy odpylić.
                              Powierzchnia powinna być wolna od smarów, tłustych
                              zabrudzeń i rdzy. W razie potrzeby podłoże
                              zagruntować Szybkim Gruntem Polimerowo-Bitumicznym
                              Evomer. Powierzchnia powinna być równa, bez
                              wżerów, raków, narostów i ubytków mechanicznych.
                              Elementy niezwiązane usunąć. Ewentualne ubytki i
                              pęknięcia wypełnić Masą Szpachlową Evomer. Aby
                              zwiększyć przyczepność do powierzchni gładkich np.
                              metalowych, zaleca się zmatowienie powierzchni za
                              pomocą szczotki drucianej. Podłoże przed aplikacją
                              może być wilgotne, ale nie mokre.
                            </p>

                            <h5 className="small-header">Aplikacja</h5>
                            <p className="acc__para">
                              Powłokę należy nanosić na oczyszczone podłoże za
                              pomocą szczotki, pędzla, wałka lub za pomocą
                              natrysku hydrodynamicznego.
                              <br />
                              Parametry natrysku hydrodynamicznego
                              <br />
                              Natrysk hydrodynamiczny (airless)
                              <br />
                              Agregat o wydajności 2,3l/min, (przy większych
                              pracach zalecane powyżej 4l/min)
                              <br />
                              Dysza o otworze 0,019” (0,48mm)
                              <br />
                              Ciśnienie aplikacji 180-190 bar.
                              <br />
                            </p>
                          </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem>
                          <AccordionItemHeading
                            onClick={this.handleClic3.bind(this)}
                          >
                            <AccordionItemButton>
                              <span className="af-icon-plus visible-icon"></span>
                              <span className="af-icon-minus hidden-icon"></span>
                              Konserwacja pokryć dachowych
                            </AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel>
                            <ul className="benefits-list">
                              <li className="list-item">
                                Na przygotowane podłoże nanieść 1 warstwę o
                                grubości ok. 0,3 – 0,4 mm
                              </li>
                              <li className="list-item">
                                Zużycie ok.: 0,35kg/m². Nierówności posypki mogą
                                zwiększyć zużycie.
                              </li>
                              <li className="list-item">
                                Czas schnięcia w temp 20oC wynosi 2 godzin
                              </li>
                            </ul>
                          </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem>
                          <AccordionItemHeading
                            onClick={this.handleClic3.bind(this)}
                          >
                            <AccordionItemButton>
                              <span className="af-icon-plus visible-icon"></span>
                              <span className="af-icon-minus hidden-icon"></span>
                              Renowacyjne powłoki wodoszczelne na dachach
                              płaskich
                            </AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel>
                            <h5 className="small-header">
                              Izolacje wodochronne:
                            </h5>
                            <ul className="benefits-list">
                              <li className="list-item">
                                2 warstwy Evomer Szybka Powłoka o grubości ok.
                                0,3 – 0,4 mm każda
                              </li>
                              <li className="list-item">
                                Zużycie całkowite na 2 warstwy ok.: 0,7 kg/m²
                              </li>
                              <li className="list-item">
                                Drugą warstwę nanosić po przeschnięciu
                                pierwszej, tak by jej nie uszkodzić
                              </li>
                            </ul>

                            <p className="acc__para">
                              Na przygotowane podłoże nałożyć Evomer Szybka
                              Powłoka w dwóch warstwach o ok. 0,4 mm każda.
                            </p>
                            <p className="acc__para">
                              W przypadku spękań i niestabilności podłoża lub
                              przejść pionowych w świeżej 1 warstwie zatopić
                              włókninę poliestrową o gramaturze: ok. 80 g/m2
                              Wyrównać wałkiem lub szczotką upewniając się, że
                              włóknina jest dokładnie nasączona powłoką.
                            </p>
                            <p className="acc__para">
                              Pozostawić do wyschnięcia – czas ok.: 2 godzin
                            </p>
                            <p className="acc__para">
                              W celu dodatkowego wydłużenia żywotności, w
                              miejscach narażonych na bezpośrednie działanie
                              słońca można powłoki zabezpieczyć dodatkowo
                              materiałem ochronnym za pomocą posypki mineralnej
                              lub powłoki bitumiczno-aluminiowej Alubit.
                            </p>
                          </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem>
                          <AccordionItemHeading
                            onClick={this.handleClic3.bind(this)}
                          >
                            <AccordionItemButton>
                              <span className="af-icon-plus visible-icon"></span>
                              <span className="af-icon-minus hidden-icon"></span>{" "}
                              Dane techniczne
                            </AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel>
                            <div className="table-wrapper">
                              <table>
                                <tbody>
                                  <tr>
                                    <td>Konsystencja</td>
                                    <td>
                                      Masa o konsystencji gęsto-płynnej,
                                      jednorodna, bez wtrąceń
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Zużycie</td>
                                    <td>
                                      Średnio 0,35 kg / 1m<sup>2</sup> /na
                                      warstwę
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      Czas schnięcia w temp +20C/50%rh [min]
                                    </td>
                                    <td>2 godz.</td>
                                  </tr>
                                  <tr>
                                    <td>Trwałość</td>
                                    <td>
                                      5 lat określono na podstawie testów
                                      starzeniowych dla typowych warunków
                                      klimatycznych
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <p className="acc__para">
                                * Czas schnięcia uzależniony jest od temperatury
                                oraz wilgotności powietrza, chłonności podłoża i
                                grubości warstwy
                              </p>
                            </div>
                          </AccordionItemPanel>
                        </AccordionItem>
                      </Accordion>
                    </div>
                    <TechnicalCard
                      pdf={
                        "/pdf/evomer-szybka-powloka-01-TDS-Karta-techniczna-produktu.pdf"
                      }
                    />
                  </div>
                  <div className="col-6 col-ml-12  roof-product">
                    <img
                      src="/img/szybka-powloka-wiadro.png"
                      className="product-large"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RoofStep3/RoofStep3.js